import type { MembershipInfo } from "@/types/auth";

interface CenterSelectorProps {
  memberships: MembershipInfo[];
  activeCenterId: number;
  onCenterChange: (centerId: number) => void;
}

export function CenterSelector({
  memberships,
  activeCenterId,
  onCenterChange,
}: CenterSelectorProps) {
  if (memberships.length <= 1) return null;

  return (
    <select
      value={String(activeCenterId)}
      onChange={(e) => onCenterChange(Number(e.target.value))}
      className="text-sm border border-gray-300 rounded px-2 py-1 bg-white text-gray-700"
    >
      {memberships.map((m) => (
        <option key={m.centerId} value={String(m.centerId)}>
          {m.centerName}
        </option>
      ))}
    </select>
  );
}
